import type { AxiosInstance } from 'axios'
import axios from 'axios'
import { toast } from 'sonner'

const apiOrigin = import.meta.env.VITE_API_URL ?? 'http://localhost:3000'

export const API_ORIGIN = apiOrigin

export const authApi = axios.create({
  baseURL: apiOrigin,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

export const api = axios.create({
  baseURL: `${apiOrigin}/v1`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

function isAuthRoute() {
  return window.location.pathname === '/entrar'
}

function buildLoginUrl() {
  const returnTo = sanitizeReturnTo(
    window.location.pathname + window.location.search
  )
  const search = new URLSearchParams()
  if (returnTo) {
    search.set('returnTo', returnTo)
  }
  const query = search.toString()
  return query ? `/entrar?${query}` : '/entrar'
}

function sanitizeReturnTo(value: string) {
  let candidate = value
  for (let i = 0; i < 5; i += 1) {
    try {
      const decoded = decodeURIComponent(candidate)
      if (decoded === candidate) break
      candidate = decoded
    } catch {
      break
    }
  }

  if (!candidate || !candidate.startsWith('/')) return null

  try {
    const url = new URL(candidate, window.location.origin)
    if (url.pathname === '/entrar') return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}

function addInterceptors(
  instance: AxiosInstance,
  redirectOnUnauthorized = true
) {
  instance.interceptors.response.use(
    (response) => response,
    (error: unknown) => {
      if (!axios.isAxiosError(error)) {
        toast.error('Erro inesperado')
        return Promise.reject(error)
      }

      // Network/offline errors are handled by the outbox + offline UI, not toasts.
      if (!error.response) {
        return Promise.reject(error)
      }

      const status = error.response?.status

      if (status === 401 && redirectOnUnauthorized && !isAuthRoute()) {
        window.location.assign(buildLoginUrl())
        return Promise.reject(error)
      }

      const message =
        error.response?.data?.message ??
        error.response?.data?.error ??
        error.message ??
        'Erro inesperado'

      toast.error(Array.isArray(message) ? message[0] : message)
      return Promise.reject(error)
    }
  )
}

addInterceptors(authApi, false)
addInterceptors(api)
